import _ from "lodash";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

interface LanguagesContext {
  language: Language;
  changeLanguage: () => void;
}

const LanguagesContext = createContext<LanguagesContext | null>(null);

interface Language {
  name: string;
  key: string;
}

interface LanguagesProviderProps {
  languages: Language[];
  languageSelected: Language;
  children: any;
}

export const LanguagesProvider = ({
  languages,
  languageSelected,
  children,
}: LanguagesProviderProps) => {
  const location = useLocation();

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [language, setLanguage] = useState<Language>(languageSelected);

  useEffect(() => {
    _updateLanguage();
  }, [searchParams]);

  const _updateLanguage = () => {
    const languageSelected = searchParams.get["lang"];

    const languageFound = languages.find(
      (language) => language.key === languageSelected
    );

    if (languageFound) {
      setLanguage(languageFound);
    }
  };

  const changeLanguage = () => {
    if (languages.forEach) {
      let indexSelected = 0;

      languages.forEach((language, index) => {
        if (language.key === languageSelected.key) {
          indexSelected = index + 1;
        }
      });

      let newLanguage = languages[0];
      if (indexSelected <= languages.length - 1) {
        newLanguage = languages[indexSelected];
      }

      const getSearch = () => {
        let searchParamsArray = [...searchParams];

        if (searchParamsArray.length > 0) {
          searchParamsArray = searchParamsArray.filter((payload) => {
            return payload[0] !== "lang";
          });
          let query = "";
          searchParamsArray.forEach((payload, index) => {
            const key = payload[0];
            const value = payload[1];
            if (index === 0) {
              query += `?`;
            } else if (index !== searchParamsArray.length - 1) {
              query += `&`;
            }

            query += `${key}=${value}`;
          });
          return query;
        } else {
          return `?lang=${newLanguage.key}`;
        }
      };

      navigate({
        pathname: location.pathname,
        search: getSearch(),
      });
    }
  };

  return (
    <LanguagesContext.Provider
      value={{
        language,
        changeLanguage,
      }}
    >
      {children}
    </LanguagesContext.Provider>
  );
};

export const useLanguagesListener = () => {
  return useContext(LanguagesContext) as LanguagesContext;
};
